





































































































import {Component} from "vue-property-decorator"
import Vue from "vue"
import JdiContent from "@/components/JdiContent.vue"

import JdiHeading from "@/components/JdiHeading.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdsTimestamp from "@/design-system/components/Timestamp/JdsTimestamp.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsLocaleProvider from "@/design-system/foundation/JdsLocaleProvider.vue"
import JdiDocs from "@/components/JdiDocs.vue";
import moment from 'moment';


@Component({
    components: {JdiDocs, JdsLocaleProvider, JdiPreview, JdsTimestamp, JdsButton, JdiStatus, JdiHeading, JdiContent}
})
export default class Timestamp extends Vue {
    locale = 'en-gb';


    pageLoad = moment();
    startOfDay = moment().startOf('day');
    yesterday = moment().subtract(1, 'day');
    tomorrow = moment().add(1, 'day');
}
